module.exports = __webpack_public_path__ + "static/media/contra.a1592702.svg";